'use client';

import type { UIComponentProps } from '@wolfejs/ui/types/UI';
import useMountedState from 'react-use/lib/useMountedState';
import { Line, LineChart, ResponsiveContainer, Tooltip } from 'recharts';

export type LineChartViewProps = UIComponentProps & { data: unknown[]; dataKey: string };

export const LineChartView = ({ data, dataKey, ...otherProps }: LineChartViewProps) => {
  const isMounted = useMountedState();
  if (!isMounted()) return null;

  return (
    <ResponsiveContainer width="100%" height="100%" minHeight="60px" minWidth="200px">
      <LineChart width={300} height={100} data={data} {...otherProps}>
        <Tooltip />
        <Line type="monotone" dataKey={dataKey} stroke="#8884d8" strokeWidth={2} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  );
};
